import { render } from "./ProductSearchSetting.vue?vue&type=template&id=6095340a&scoped=true"
import script from "./ProductSearchSetting.vue?vue&type=script&lang=js"
export * from "./ProductSearchSetting.vue?vue&type=script&lang=js"

import "./ProductSearchSetting.vue?vue&type=style&index=0&id=6095340a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6095340a"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductSearchSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6095340a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6095340a', __exports__)) {
    api.reload('6095340a', __exports__)
  }
  
  module.hot.accept("./ProductSearchSetting.vue?vue&type=template&id=6095340a&scoped=true", () => {
    api.rerender('6095340a', render)
  })

}


export default __exports__